import SplashLayout2026 from "./SplashLayout2026";

interface Splash2026Props {
  id: string;
  zoom: number;
}

/** Releases splash, 2026 design, 640x400. The 2025 design of this canvas is Splash. */
const Splash2026 = ({id, zoom}: Splash2026Props) => (
  <SplashLayout2026 id={id} zoom={zoom} scale={1} fallbackTransformId="Splash" />
);

export default Splash2026;
